import React, { useState, useEffect, useCallback, useLayoutEffect, useMemo } from 'react';
import Parse from 'html-react-parser';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
//react-redux
import { useDispatch, useSelector } from 'react-redux';
//components
import Text from 'components/Text';
import Modal from "components/Modal";
import { Button } from "components/Button";
import toast from 'components/Toast/dispatch';
import ModalCD from "pages/Quotes/Details/Modal";
import { LastHits } from '../components/LastHits';
import { Visibility } from 'components/Visibility';
import { VisibilityConditional } from 'components/VisibilityConditional';
import { Row, Column } from 'components/Layout/Grid';
import QuotesMapping from "../Mapping/QuotesMapping";
import { ScrollToTop } from '../components/ScrollToTop';
import { ActionTag } from '../components/Tags/ActionTag';
import { ConfirmedOrdersAlert } from '../components/Tags/ConfirmedOrdersAlert';
import { ErrorMessages } from '../components/ErrorMessages';
import Select from "pages/Quotes/components/generics/Select";
import { Subtitles } from '../components/generics/Subtitles';
import ModalLoader from '../components/generics/Modal/Loader';
import { BackButton } from '../components/generics/BackButton';
import { toastify as message } from "components/Toastify/utils";
import { OrderReportButton } from '../components/OrderReportButton';
import Tooltip from "../components/generics/tooltips/TooltipButton";
import { DistributionCenterTab } from '../components/DistributionCenterTab';
import QuoteHeaderInformations from '../components/QuoteHeaderInformations';
import FinancialPendingMatterModal from '../components/generics/Modal/FinancialPendingMatterModal';
import PriceHistoryModal from "pages/Quotes/components/generics/Modal/PriceHistoryModal/PriceHistoryModal";
import ObservationFieldModal from '../components/generics/Modal/ObservationFieldModal/ObservationFieldModal';
//services
import BCGServices from "services/bcg.service";
import QuoteServices from 'services/quote.service';
import QuoteBionexoServices from "services/quoteBionexo.service";
//assets
import ObsIconSaved from "img/SavedObsIcon.svg";
import ErrorIcon from "img/error-img.svg";
import ObsIcon from "img/ObsIcon.svg";
import DownloadTechnicalSheetBtn from "img/download-technical-sheet.svg";
//styles
import '../styles.scss';
import './styles.scss';
//models
import { IQuoteAnalyzed } from 'models/QuoteBionexo';
import DomainSettingService from 'services/domainSetting.service';
import KeycloakPubServiceInstance from 'services/keycloakpubsub.service';
import PaymentTermModal from "../Mapping/PaymentTermModal/PaymentTermModal";
//interfaces
import { PaymentMethodsTabsProps } from './interface';
import { ProductSelectedProps } from '../Details/interface';
import { QuotationOrigin, QuotationOriginType, StatusType, SupplierStatusType } from 'components/Table/interface';
import { IFinancialCreditInformations } from '../components/generics/Modal/FinancialPendingMatterModal/interface';
//stores
import store from 'store';
import { RootState } from 'store/ducks';
import DistributionCenterContext from '../store/distribution-center-context';
//context
import { useTabsContext } from 'contexts/Tabs';
import { useDetailsQuoteContext } from 'contexts/DetailsQuote';
//generics
import { DisableButton } from 'utils/DisableButton';
import { IsNullOrEmpty } from 'utils/StringNullOrEmpty';
import { handleUserRedirect, handleCreatePdf } from '../Dashboard/utils';
import { newTabsOrderWithSegments, renderAlertUpdatedStatus } from './utils';
import { subtitlesQuoteDetails } from '../components/generics/Subtitles/utils';
import { checkIsBudgetSavedOthersUsers, getBlockedBranches } from '../Details/utils';
import { UpdateApprovedMapAutomaticProps } from 'models/MapProduct';
import { IQuoteDetailItem } from 'models/QuoteDetailItem';
import MapProductService from 'services/quoteMapProduct.service';
import { IItemDeclined } from 'models/portalModels/ItemDeclined';

const SavedInMoney: React.FC = () => {
  //navigation
  const location: any = useLocation();
  const { id } = useParams<any>();
  const { state, pathname } = location;

  //const environment
  const blockedSimultaneousAccess = process.env.REACT_APP_BLOCKED_SIMULTANEOUS_ACCESS_SENT;
  //redux 
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.user);

  const [quoteId, setQuoteId] = useState<string | undefined>('');
  //Details table
  const [hasMore, setHasMore] = useState(true);
  const [, setShouldReset] = useState(false);
  const [distributionCenterSelected, setDistributionCenterSelected] = useState('');
  const [productSelected, setProductSelected] = useState<ProductSelectedProps[]>([]);
  const [newProductSelected, setNewProductSelected] = useState<ProductSelectedProps[]>([]);
  const [selectCD, setSelectCD] = useState<any>("");
  //Modals
  const [isDeparaModalDisplayed, setIsDeparaModalDisplayed] = useState(false);
  const [selectCDModal, setSelectCDModal] = useState<any>("");
  const [openModal, setOpenModal] = useState({ isOpen: false, isCancelButtonClicked: false, firstLoad: true });
  const [openItemObsModal, setOpenItemObsModal] = useState(false);
  const [financialPendingMatterModal, setFinancialPendingMatterModal] = useState(false);

  const [viewSentQuotes, setViewSentQuotes] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  const [supplierNote, setSupplierNote] = useState("");
  const [obsIcon, setObsIcon] = useState<boolean>(false);
  const [qtdItemsAlreadySent, setQtdItemsAlreadySent] = useState<number>(0);
  const [paymentMethods, setPaymentMethods] = useState<PaymentMethodsTabsProps[]>([]);
  const [refreshControl, setRefreshControl] = useState<boolean>(false);
  const [, setCategoryQuote] = useState("");
  const [oldSegmentSelected, setOldSegmentSelected] = useState("");
  const [financialCreditInformations, setFinancialCreditInformations] = useState<Array<IFinancialCreditInformations>>([]);
  const [removeAllFromToSegment, setRemoveAllFromToSegment] = useState(true);
  const [isClickButtonFinally, setIsClickButtonFinally] = useState(false);
  const [loading, setLoading] = useState(false);
  const [enableButtonApproveSuggestions, setEnableButtonApproveSuggestions] = useState<boolean>(false);
  const [preOrderDistributionCenters, setPreOrderDistributionCenters] = useState<string>('');
  const [isDownloadingQuotationMirror, setIsDownloadingQuotationMirror] = useState(false);

  const _domainSettingService = new DomainSettingService();
  const _quoteServices = new QuoteServices();
  const _bcgService = new BCGServices();
  const _quoteBionexoServices = new QuoteBionexoServices();

  const { setDisableTabs } = useTabsContext();
  const {
    quoteItem,
    currentPage,
    setUseMoney,
    quoteDetail,
    setQuoteItem,
    sequenceNumber,
    setQuoteDetail,
    setCurrentPage,
    isQuoteExpired,
    itemPriceHistory,
    setFirstLoadPage,
    renderAgainMoney,
    setUpdateChecked,
    setSequenceNumber,
    setRenderAgainMoney,
    showPriceHistoryModal,
    resetItemPriceHistory,
    modalPaymentTermModal,
    secondDetailPageRender,
    setModalPaymentTermModal,
    setSecondDetailPageRender
  } = useDetailsQuoteContext();

  const navigate = useNavigate();

  const _mapProductService = new MapProductService();

  const getPreOrderDistributionCenters = async (quotationCode: string) => {
    try {
      const result = await _quoteBionexoServices.getRescuedCds(quotationCode);
      if (result?.data) {
        const { distributionCenters, hasPendingOrders } = result.data;
        
        if (hasPendingOrders && distributionCenters && distributionCenters.length > 0) {
          setPreOrderDistributionCenters(distributionCenters);
        } else {
          setPreOrderDistributionCenters('');
        }
      } else {
        setPreOrderDistributionCenters('');
      }
    } catch (error: any) {
      if (error?.response?.status === 404) {
        setPreOrderDistributionCenters('');
      } else {
        console.error('Erro ao buscar CDs com pedidos resgatados:', error);
        setPreOrderDistributionCenters('');
      }
    }
  };

  const handleRedirectToOrders = () => {
    navigate('/cotacoes-dashboard', { 
      state: { 
        redirectQuote: true, 
        filterText: quoteDetail?.quoteCode 
      }
    });
  };

  const isOrder = quoteDetail?.status === StatusType.PURCHASE_ORDER;
  const statusAnsweredPortal = quoteDetail?.supplierStatus === SupplierStatusType.ANSWERED_PORTAL;
  const ableNegotiacionBtn = (isQuoteExpired && IsNullOrEmpty(quoteDetail?.distributionCentersNegotiation?.find((item) => item === distributionCenterSelected)));
  const unavailableCanceledQuote = quoteDetail?.status === StatusType.CANCELED;

  const refreshTableQuotesDashboard = () => {
    dispatch({ type: "RELOAD_TABLE_QUOTES", data: { reload: true } });
  };

  const checkUserAccessQuote = async (idQuoteAccessLink: string) => {
    const response = await _quoteServices.checkQuotationViewed(idQuoteAccessLink);

    const users: string[] = response.data.data.user;

    if (users && !users.includes(user?.fullName ?? '') && (blockedSimultaneousAccess)) {
      navigate('/cotacoes-dashboard', { state: { redirectQuote: true } });

      const description = Parse(`<p class='text-styles color-blue-gray mt-3 text-wrap text-center description-quote-blocked'>Essa cotação esta sendo manipulada pelo colaborador <b>${users[0]}</b>. Aguarde a finalização para acessar as informações.</p>`);
      toast.errorCustom('Importante!', description, ErrorIcon, true, 'Fechar', 19, 14, true, refreshTableQuotesDashboard);
    }
  };

  useEffect(() => {
    if (quoteDetail)
      setCategoryQuote(quoteDetail.categoryMafra);
  }, [quoteDetail]);

  const handleTooltipText = () => {
    if (isOrder) {
      return "Pedidos não podem ser atualizados.";
    } else if (distributionCenterSelected !== 'default' && quoteDetail?.supplierStatus !== SupplierStatusType.PENDING_MONEY && isQuoteExpired) {
      return "Cotações expiradas não podem ser atualizadas.";
    } else if (distributionCenterSelected === 'default' && quoteDetail?.supplierStatus !== SupplierStatusType.PENDING_MONEY && isQuoteExpired) {
      return "Cotações expiradas não podem ser enviadas.";
    } else if (distributionCenterSelected !== 'default' && quoteDetail?.supplierStatus === SupplierStatusType.PENDING_MONEY) {
      return "Cotações com status 'Pendente Money' não podem ser atualizadas.";
    } else if (distributionCenterSelected === 'default' && quoteDetail?.supplierStatus === SupplierStatusType.PENDING_MONEY) {
      return "Cotações com status 'Pendente Money' não podem ser enviadas.";
    } else if (quoteDetail?.status === StatusType.PROCESSING) {
      return "Cotações com status 'Processando' não podem ser enviadas.";
    }

    return 'Selecione 1 produto para continuar.';
  };

  function useForceUpdate() {
    const [value, setValue] = useState(0);
    return () => setValue(value + 1);
  }

  const getViewSentQuotes = async () => {
    const response = await _domainSettingService
      .get(undefined, undefined, undefined, {
        and: [
          { identifier: { eq: 'FlagSentQuotes' } },
          { enabled: { eq: true } },
        ],
      });

    const { data } = response;

    setViewSentQuotes(JSON.parse(data[0].value));
  };

  useEffect(() => {
    getViewSentQuotes();

    return () => {
      setCurrentPage(0);
      setFirstLoadPage(true);
      setQuoteItem(undefined);
      setQuoteDetail(undefined);
      dispatch({ type: 'SET_ALL_BUDGETS_SAVED', data: [] });
    };
  }, []);

  const forceUpdate = useForceUpdate();

  const [distributionCenter, setDistributionCenters] = useState<any>({ distributionCenters: [] });

  const quotesDetailsStore = useSelector((state: RootState) => state.quotesDetails);
  const savedBudgets = useSelector((state: RootState) => state.savedBudgets) ?? [];
  const updateBudgetSaved = useSelector((state: RootState) => state.updateBudgetSaved);
  const toastify = useSelector((state: RootState) => state.toastify);

  const hideDeParaModal = () => {
    setSequenceNumber("");
    setIsDeparaModalDisplayed(false);
    setEnableButtonApproveSuggestions(false);
    forceUpdate();
    document.body.style.overflow = "visible";
  };

  const showDeParaModal = (quoteId: string, sequenceNumber: string) => {
    setSequenceNumber(sequenceNumber);
    setIsDeparaModalDisplayed(true);
    document.body.style.overflow = "hidden";
  };

  const analyzedQuote = async (showToastQuote: boolean) => {
    const idQuoteLink = pathname.split('/')[2];

    const response = await _quoteServices.CheckAnalyzedQuote(idQuoteLink);
    if (response && showToastQuote) {
      dispatch({ type: 'SET_QUOTE_ANALYZED' });
      dispatch({ type: 'CLOSE_TOAST' });
    }
  };

  const getDetail = useCallback(async (quoteIdParam: string) => {
    KeycloakPubServiceInstance.subscribe(async () => {
      setQuoteItem(undefined);

      const result = await _quoteServices.quoteDetailsWithCD(quoteIdParam);

      if (result?.data && !result?.error) {
        setRemoveAllFromToSegment(false);
        setQuoteDetail(result.data);
        
        if (result.data.hasPreOrder && result.data.quoteCode) {
          getPreOrderDistributionCenters(result.data.quoteCode);
        }
        
        dispatch({
          type: "SET_CUSTOMER_CODE",
          customerCode: result.data.customerCode,
        });
        getUnblockedDCs(quoteId ?? "", result.data.customerCode);
        setSupplierNote(result.data.supplierNote);
        setDistributionCenterSelected(result.data.distributionCentersList[0].distributionCenter);
      }
    });
  }, [quoteId]);

  const getDetailUpdated = async () => {
    const result = await _quoteServices.quoteDetailsWithCD(quoteId);

    if (result?.data && !result?.error && quoteDetail && result.data.status !== StatusType.PROCESSING) {
      setQuoteDetail({ ...quoteDetail, integrationMessages: result.data.integrationMessages, status: result.data.status, distributionCentersList: result.data.distributionCentersList });
      newTabsOrderWithSegments(
        result.data.distributionCentersList,
        distributionCenterSelected,
        setDistributionCenterSelected,
        setHasMore,
        setCurrentPage,
        setQuoteItem,
        setRemoveAllFromToSegment,
        quoteDetail.distributionCentersList
      );
    }
    else
      renderAlertUpdatedStatus(navigate, checkStatusQuotation, true);

    setLoading(false);
  };

  const checkStatusQuotation = () => {
    dispatch({ type: 'CLOSE_TOAST' });
    setLoading(true);

    getDetailUpdated();
  };

  const allBudgetsSavedInQuote = async (distributionCenterTab?: string, isDiscarded?: boolean, isFinally?: boolean) => {
    const response = await _quoteServices.allBudgetsSavedInQuote(quoteId ?? "");
    if (response.data) {
      let productsFiltered: ProductSelectedProps[] = [];

      if ((IsNullOrEmpty(distributionCenterTab) && distributionCenterSelected !== 'default') || (!IsNullOrEmpty(distributionCenterTab) && distributionCenterTab !== 'default'))
        productsFiltered = response.data.data.filter((item: ProductSelectedProps) => item.tabSelected !== 'default');
      else
        productsFiltered = response.data.data.filter((item: ProductSelectedProps) => item.tabSelected === 'default');

      if ((newProductSelected.length === 0 && IsNullOrEmpty(distributionCenterTab)) || productSelected.length === 0) {
        setProductSelected(productsFiltered);
        setNewProductSelected(productsFiltered);
      } else
        setNewProductSelected(productsFiltered);

      if (isDiscarded)
        handleChangeProductSelected(productsFiltered);

      if (isFinally)
        renderAlertUpdatedStatus(navigate, checkStatusQuotation);

      if (isClickButtonFinally && quoteItem) {
        const newQuoteItem = { ...quoteItem };
        const sequenceNumberSent = productSelected.map(p => p.sequenceNumber);

        sequenceNumberSent.forEach(sequence => {
          const index = newQuoteItem.data?.findIndex(item => item.sequenceNumber === sequence);

          if (!IsNullOrEmpty(index) && index !== -1) {
            if (distributionCenterSelected === "default")
              newQuoteItem.data?.splice(index!, 1);
            else
              setUpdateChecked(true);
          }
        });

        setProductSelected([]);
        setNewProductSelected([]);
        setIsClickButtonFinally(false);
        setQuoteItem({ ...quoteItem, data: newQuoteItem.data });
      }
    }
  };

  const handleChangeProductSelected = (productsFiltered?: ProductSelectedProps[]) => {
    setProductSelected(productsFiltered ?? newProductSelected);
  };

  const handleOpenFinancialPendingMatterModal = () => {
    getFinancialCreditInformations();
    setFinancialPendingMatterModal(true);
  };

  const handleCloseFinancialPendingMatterModal = () => {
    setFinancialPendingMatterModal(false);
  };

  useEffect(() => {
    if (!quotesDetailsStore?.distributionCenter) return;
    setSelectCD(quotesDetailsStore?.distributionCenter);

    return () => {
      setStorageCD("");
    };
  }, [quotesDetailsStore?.distributionCenter]);

  useEffect(() => {
    if (quoteId) {
      dispatch({ type: 'BUDGET_SENT', data: { sent: distributionCenterSelected !== 'default' } });
      allBudgetsSavedInQuote();
    }
  }, [quoteId, updateBudgetSaved?.isUpdate]);

  useEffect(() => {
    if (renderAgainMoney) {
      setSecondDetailPageRender(false);
      getSuggestionDetailsSendQuotation(true);
    }
  }, [renderAgainMoney]);

  const getSuggestionDetailsSendQuotation = (useMoney: boolean) => {
    setDisableTabs(true);
    setUseMoney(false);

    KeycloakPubServiceInstance.subscribe(async () => {
      const result = await _quoteServices.suggestionDetailsSendQuotation(
        quoteId ?? "",
        distributionCenterSelected,
        useMoney,
        currentPage + 1
      );

      if (result?.data && Array.isArray(result?.data)) {
        const { error, data, totalPages, pageSize, total } = result;

        let loadedPage = currentPage + 1;
        const oldQuoteItem: any = quoteItem?.data || [];

        setQuoteItem({
          error,
          data: currentPage === 0 ? [...data] : [...oldQuoteItem, ...data],
          totalPages,
          pageSize: pageSize,
          total,
        });

        if (useMoney) {
          setUseMoney(true);
          setDisableTabs(false);
          setFirstLoadPage(false);
          setSecondDetailPageRender(true);
          setHasMore(loadedPage !== totalPages);
          setOpenModal({ ...openModal, firstLoad: false });
        }
      } else {
        if (useMoney) {
          setUseMoney(true);
          setDisableTabs(false);
          setFirstLoadPage(false);
          setRenderAgainMoney(false);
          setSecondDetailPageRender(true);
        } else {
          setQuoteItem({
            error: true,
            pageSize: 0,
            total: 0,
            totalPages: 0,
            data: undefined
          });
        }
        setHasMore(false);
        setRefreshControl(false);
      }
    });
  };

  useEffect(() => {
    if (refreshControl) {
      setQuoteItem(undefined);
    }

    if (!hasMore && !refreshControl && quoteItem || !quoteId ||
      (!quoteItem?.data?.length && currentPage !== 0) ||
      IsNullOrEmpty(distributionCenterSelected) ||
      (!selectCD && distributionCenterSelected === "default") ||
      !selectCD ||
      (!removeAllFromToSegment && ((distributionCenterSelected === oldSegmentSelected))) ||
      !secondDetailPageRender && currentPage !== 0
    )
      return;

    setSecondDetailPageRender(false);
    Promise.all([getSuggestionDetailsSendQuotation(false), getSuggestionDetailsSendQuotation(true)]);
  }, [currentPage, quoteId, distributionCenterSelected, selectCD, refreshControl, hasMore, quoteDetail]);

  useEffect(() => {
    if (supplierNote || quoteDetail?.notes) {
      setObsIcon(true);
    } else {
      setObsIcon(false);
    }
  }, [supplierNote, quoteDetail]);

  const reloadTable = (quoteIdReload: string) => {
    KeycloakPubServiceInstance.subscribe(async () => {
      const result = await _quoteServices.quoteDetailsWithCD(quoteIdReload);

      if (result?.data && !result?.error) {
        setRemoveAllFromToSegment(false);
        setCategoryQuote(result.data.categoryMafra);
      }
    });
  };

  const getUnblockedDCs = useCallback(async (quoteIdentifier: string, customerCode: string) => {
    const clientId = customerCode;
    KeycloakPubServiceInstance.subscribe(async () => {
      await new Promise(resolve => setTimeout(resolve, 100));
      
      let origin = Number(quoteDetail?.origin) || QuotationOrigin.BIONEXO;
      
      const pageText = document.body.textContent || document.body.innerText || '';
      if (pageText.includes('MVM')) {
        origin = QuotationOrigin.MVM;
      }
      
      const result = await _domainSettingService.getUnblockedDistributionCenters(clientId, origin);
      const blockedBranches = await getBlockedBranches();

      if (result?.data) {
        const { data } = result;
        if (data instanceof Array) {
          const options = data?.map((unlockedDistributionCenter: any) => {
            return {
              id: clientId,
              value: unlockedDistributionCenter.branchName,
              disabled: unlockedDistributionCenter.blocked,
              label: unlockedDistributionCenter.description,
            };
          });
          setDistributionCenters({
            distributionCenters: options.filter((item: any) => !item.disabled && !blockedBranches.includes(item.value)),
          });
        } else {
          toast.error(data);
        }
      } else {
        toast.error(
          "Não foi possível carregar Centro de Distribuições. Tente carregar a página novamente, por favor."
        );
      }
    });
  }, [quoteDetail?.origin]);

  const resetGrid = useCallback(
    (cdValue = "") => {
      if (!quoteId || (!quotesDetailsStore?.distributionCenter && !cdValue))
        return;

      KeycloakPubServiceInstance.subscribe(async () => {
        await _quoteServices.resetCDsUnsetItems({
          quoteId,
          distributionCenter: cdValue
            ? cdValue
            : quotesDetailsStore?.distributionCenter ?? "",
        });
        setQuoteItem(undefined);

        setCurrentPage(0);
        setProductSelected([]);

        if (cdValue) setStorageCD(cdValue);
        setHasMore(true);
      });
    },
    [quoteId, quotesDetailsStore?.distributionCenter]
  );

  const setStorageCD = (value: any) => {
    store.dispatch({ type: "SET_DISTRIBUTION_CENTER", value });
  };

  const setReset = () => {
    setOpenModal({ isOpen: false, isCancelButtonClicked: false, firstLoad: false });
    setShouldReset(true);
    resetGrid(selectCDModal);
  };

  const handleCloseDcModal = () => {
    if (quoteDetail?.distributionCentersList.length === 1 && quoteDetail?.distributionCentersList[0].distributionCenter === "default") {
      navigate('/cotacoes-dashboard');
    } else {
      setOpenModal({ isOpen: false, isCancelButtonClicked: true, firstLoad: false });
      setDistributionCenterSelected(quoteDetail?.distributionCentersList ? quoteDetail?.distributionCentersList[0]?.distributionCenter : "");
    }
  };

  useLayoutEffect(() => {
    if (!quoteDetail) {
      if (quoteId !== '') {
        getDetail(quoteId ?? "");
      } else {
        setQuoteId(id);
      }
    }
  }, [quoteId, quoteDetail]);

  useEffect(() => {
    user && handleUserRedirect(user, history);
  }, [user]);

  useEffect(() => {
    const idQuoteLink = pathname.split('/')[2];

    if (user) {
      dataBCG();
      checkUserAccessQuote(idQuoteLink as string);
    }
  }, [state]);

  const dataUserBCG = useMemo(async () => {
    if (IsNullOrEmpty(user?.representative)) {
      try {
        const response = await _bcgService.getUserByUserName(user?.username ?? "");
        if (response.status === 200) {
          dispatch({ type: 'SET_REPRESENTATIVE_USER', representative: response.data.representativeCode, buBCG: response.data.identifier, isBCGUser: true });
          return { representative: response.data.representativeCode, bu: response.data.identifier };
        }
      } catch {
        // ignore
      }
      dispatch({ type: 'SET_REPRESENTATIVE_USER', representative: "", isBCGUser: false, buBCG: "" });
      return { representative: "", bu: "" };
    } else
      return { representative: user?.representative, bu: user?.buBCG };
  }, []);

  const dataBCG = async () => await dataUserBCG;

  useEffect(() => {
    const idQuoteLink = pathname.split('/')[2];

    if (id || idQuoteLink) {
      return () => {
        _quoteServices.updateFinishDate(String(id || idQuoteLink));

        dispatch({
          type: 'SET_QUOTE_ITEM',
          data: { id: id || idQuoteLink, blockedQuote: blockedSimultaneousAccess }
        });
      };
    }
  }, [state, blockedSimultaneousAccess]);

  useEffect(() => {
    if (distributionCenterSelected === 'default' && !selectCD)
      setOpenModal({ isOpen: true, isCancelButtonClicked: false, firstLoad: false });

    if (quoteId) {
      dispatch({ type: 'BUDGET_SENT', data: { sent: distributionCenterSelected !== 'default' } });
    }
  }, [distributionCenterSelected]);

  const handleDisableButton = () => {
    if (quoteDetail) {
      const isDefaultDistributionCenter = distributionCenterSelected === 'default';
      const isPendingMoney = quoteDetail.supplierStatus === SupplierStatusType.PENDING_MONEY;
      const isPurchaseOrderOrProcessing = quoteDetail.status === StatusType.PURCHASE_ORDER || quoteDetail.status === StatusType.PROCESSING;
      const isPendingMoneyAndNotDefaultDC = isPendingMoney && !isDefaultDistributionCenter;
      const existProductSelected = productSelected?.length > 0;

      if ((isQuoteExpired && statusAnsweredPortal && isDefaultDistributionCenter) ||
          isPurchaseOrderOrProcessing ||
          isPendingMoneyAndNotDefaultDC ||
          ableNegotiacionBtn) {
        setDisableBtn(true);
      } else if ((!isQuoteExpired && existProductSelected) || 
          (isQuoteExpired && statusAnsweredPortal &&
          !isDefaultDistributionCenter && existProductSelected))
        setDisableBtn(false);
      else
        setDisableBtn(true);
      setSelectCD(quoteDetail?.distributionCenterDefault);
    }
  };

  useEffect(() => {
    handleDisableButton();
  }, [productSelected, quoteDetail]);

  const bgButton = productSelected?.length && quoteDetail?.status !== StatusType.PROCESSING && ((!isQuoteExpired && quoteDetail?.supplierStatus !== SupplierStatusType.PENDING_MONEY) || (isQuoteExpired && distributionCenterSelected !== 'default' && statusAnsweredPortal)) ? "bg-greenDarkViveo" : "buttonUpdateQuote";
  const bgButtonNotSent = productSelected?.length && !isQuoteExpired ? "bg-greenDarkViveo" : "buttonUpdateQuote";
  const textColor = `${productSelected?.length && quoteDetail?.status !== StatusType.PROCESSING && ((!isQuoteExpired && quoteDetail?.supplierStatus !== SupplierStatusType.PENDING_MONEY) || (isQuoteExpired && distributionCenterSelected !== 'default' && statusAnsweredPortal)) ? "color-white" : "color-dark-gray"} font-bold px-3`;
  const textColorNotSent = `${productSelected?.length && !isQuoteExpired ? "color-white" : "color-dark-gray"} font-bold px-3`;

  const classIconObsQuote = `margin ${DisableButton(isOrder)}`;
  const iconObsVisible = obsIcon ?
    <img src={ObsIconSaved} className={classIconObsQuote} alt='' /> :
    <img src={ObsIcon} className={classIconObsQuote} alt='' />;

  const resetCDUnsetItems = (newCD: string) => {
    dispatch({ type: 'SET_ALL_BUDGETS_SAVED', data: [] });
    setCurrentPage(0);
    resetGrid(newCD);
    quoteDetail && setQuoteDetail({ ...quoteDetail, distributionCenterDefault: newCD });
    dispatch({ type: "CLOSE_TOAST" });
  };

  const changeCDAndResetQuote = (cdValue: string) => {
    if (!cdValue) return;
    toast.yesNo(
      "Atenção! Ao trocar o CD de gravação, todas \n os orçamentos salvos serão descartados.\n\n Deseja prosseguir com a alteração do CD?",
      () => { resetCDUnsetItems(cdValue); },
      "Trocar CD",
      "Cancelar"
    );
  };

  const getFinancialCreditInformations = async () => {
    KeycloakPubServiceInstance.subscribe(async () => {
      const result = await _quoteServices.getFinancialCreditInformations(quoteDetail?.customerCode!);
      if (result.status === 200) {
        setFinancialCreditInformations(result.data.data);
      }
    });
  };

  const renderButtonObs = () => (
    <Column className={`obsIcon ${isOrder ? 'cursor-not-allowed' : ''}`} onClick={() => !isOrder && setOpenItemObsModal(true)}>
      {iconObsVisible}
      <Text>Observação</Text>
    </Column>
  );

  const getQtdItemsTotal = useCallback(() => {
    if (distributionCenterSelected && distributionCenterSelected === 'default') {
      return quoteItem?.data?.length;
    } else {
      return qtdItemsAlreadySent;
    }
  }, [distributionCenterSelected, quoteItem]);

  const moneyBudgetValue = quoteDetail?.moneyBudgets?.filter((budget) => budget.billedLocationAlias === distributionCenterSelected);

  const integrationMessages = quoteDetail?.integrationMessages?.find((message) => message.distributionCenter === distributionCenterSelected);

  const integrationMessagesStatusViveo = integrationMessages?.statusViveo;

  const errorMessageVisible = ((integrationMessages?.statusViveo === SupplierStatusType.PENDING_MONEY && !IsNullOrEmpty(integrationMessages?.message)) ||
    (quoteDetail?.supplierStatus === SupplierStatusType.PENDING_MONEY && !IsNullOrEmpty(quoteDetail?.supplierStatusMessage))) && distributionCenterSelected !== 'default' && integrationMessagesStatusViveo !== SupplierStatusType.ANSWERED_PORTAL;

  const analizedItem: IQuoteAnalyzed[] = quoteDetail?.quoteAnalyzed?.filter((item: IQuoteAnalyzed) => item.analyzed) ?? [];

  const toastAnalyzed = (showToastAnalyzed: boolean) =>
    toast.yesNo('Marcar esta cotação como ANALISADA?',
      () => analyzedQuote(showToastAnalyzed),
      'Sim', 'Não', 100, 14);

  const popState = useCallback((showToast: boolean) => {
    if (quoteDetail && (!analizedItem || analizedItem.length === 0) && quoteDetail.quoteWithAutomaticItems) {
      if (showToast)
        toastAnalyzed(showToast);
      else
        analyzedQuote(showToast);
    }
  }, [quoteDetail]);

  useEffect(() => {
    window.onpopstate = function (e: Event) {
      e.preventDefault();
      popState(true);
    };
  }, [quoteDetail]);

  useEffect(() => {
    if (toastify.show) {
      message.success("De/Para salvo com sucesso");
    }

    dispatch({ type: "SHOW_TOASTIFY", data: { show: false } });
  }, [toastify.show]);

  const distributionCentersButtonsHide = ['default', 'outPortfolio'];

  const textAlertItemBionexo = Parse(`Os CD's indicados possuem itens que foram respondidos diretamente na Bionexo. <br /> Acesse a Bionexo para ver quais itens foram respondidos.`);

  const previouslyAddedToBionexo = quoteDetail?.distributionCentersList?.find((message) => message.distributionCenter === distributionCenterSelected);

  const handleUpdateQuotation = () => {
    checkIsBudgetSavedOthersUsers(
      setModalPaymentTermModal,
      savedBudgets,
      dispatch,
      user?.fullName ?? '',
      setIsClickButtonFinally
    );
  };

  const handleSendNegotiation = () => {
    setModalPaymentTermModal(true);
  };

  const handleOnCloseAction = () => {
    setModalPaymentTermModal(false);
    setIsClickButtonFinally(false);
    handleChangeProductSelected();
  };

  const handleDownloadMirror = async () => {
    if (!id) return;

    setIsDownloadingQuotationMirror(true);
    const response = await _quoteBionexoServices.downloadQuotationDetails(id);

    if (response.status === 200) {
      handleCreatePdf(response, "Espelho-Cotacao", undefined, quoteDetail?.quoteCode, quoteDetail?.origin, true);

      try {
        await _quoteServices.saveDownloadHistory(id);
      } catch (error) {
        console.error('Erro ao salvar histórico de baixa do espelho:', error);
      }
    } else {
      message.error('Ocorreu um erro durante a requisição');
    }

    setIsDownloadingQuotationMirror(false);
  };

  const refreshItem = useCallback(
    (
      field: string,
      value?: any,
      sequenceNumber?: string,
      filterDetail?: string,
      valueFilterDetail?: any
    ) => {
      if (!quoteItem?.data) return;

      const fields = field.split(".");

      let index: number = quoteItem?.data.findIndex(
        (item) => item.sequenceNumber == sequenceNumber
      );
      let data = Object.assign(quoteItem?.data) as Array<IQuoteDetailItem>;

      let item = {};

      type field0 = keyof typeof data[0];

      if (fields.length == 1) {
        let detailItemObj: IQuoteDetailItem = { [fields[0] as field0]: value };
        item = { ...data[index], ...detailItemObj };
      } else if (fields.length == 2) {
        const itemDetail = data[index][fields[0] as field0];
        if (!itemDetail.length) return;

        const indexDetail = itemDetail.findIndex(
          (item: any) => item[filterDetail!] == valueFilterDetail
        );

        if (indexDetail < 0) return;

        let detailItemObj = { [fields[1]]: value };
        itemDetail[indexDetail] = {
          ...itemDetail[indexDetail],
          ...detailItemObj,
        };

        item = { ...data[index], [fields[0]]: itemDetail };
      }

      data[index] = item;

      setQuoteItem({ ...quoteItem, data: data });
    }, [quoteItem]);

    const reproveMapProduct = async (item: IQuoteDetailItem) => {
      const modalData: IItemDeclined = {
        automaticItemDeclinedType: "",
        automaticItemDeclinedMessage: "",
      };
  
      const errorMessage = "Não foi possível remover a sugestão";
  
      if (!quoteId || !item.sequenceNumber) {
        message.error(errorMessage);  
        return;
      };
  
      const quoteData = quoteItem?.data;
  
      const itemData = quoteData ? quoteData.find((data) => data.sequenceNumber === item.sequenceNumber) : undefined
  
      if (!itemData || !itemData.productsSuggestion) {
        message.error(errorMessage);  
        return;
      }
  
      const suggestedIndex = itemData.productsSuggestion.findIndex((data) => data.id === item.id);
  
      if (suggestedIndex > -1) {
        itemData.productsSuggestion.splice(suggestedIndex, 1);
      }
  
      const response = await _mapProductService.updateDeclinedItemReason(quoteId, item.sequenceNumber!, item.id!, Number(item.sequenceNumber), modalData);
  
      if (response.status === 200) {
        const newProductSuggestion = itemData.productsSuggestion[0];
  
        if (newProductSuggestion) {
          newProductSuggestion.suggested = true;
          setEnableButtonApproveSuggestions(true);
        }
  
        message.success("Sugestão removida com sucesso.");
        refreshItem('productsSuggestion', itemData?.productsSuggestion, item.sequenceNumber);
        showDeParaModal(quoteId, item.sequenceNumber);
      } else {
        message.error(errorMessage);
      }
    };
  
    const approveMapProduct = async (id: string, sequenceNumber: number, data: UpdateApprovedMapAutomaticProps) => {
      setLoading(true);
      
      const quoteData = quoteItem?.data;
      const itemData = quoteData ? quoteData.find((item) => Number(item.sequenceNumber) === sequenceNumber) : undefined
  
      const suggested = itemData ? itemData.productsSuggestion?.find((data) => data.id === id) : undefined
  
      if (suggested) {
        suggested.isApproved = true;
        suggested.isCreatedAutomatically = false;
      }
  
      const response = await _mapProductService.UpdateApprovedMapAutomatic(data);
  
      if (response.status === 200) {
        message.success("De/Para aprovado");
        refreshItem('productsSuggestion', itemData?.productsSuggestion, sequenceNumber.toString());
      } else
        message.error("Não foi possível atualizar o De/Para");
  
      setLoading(false);
  };

  return (
    <DistributionCenterContext.Provider
      value={{
        distributionCenters: distributionCenter.distributionCenters,
        quoteId: quoteId,
      }}
    >
      <Visibility visible={loading}>
        <ModalLoader />
      </Visibility>

      <BackButton onClick={() => popState(true)} />

      <Row className="headerQuotesSent">
        <Row className="align-center">
          <Column className="flex-5 quote-title">
            <p className="main-title-quote">{quoteDetail?.customerName} | {quoteDetail?.customerUF}</p>
            <Row>
              <Column className="flex-center flex-5 mt-1">
                <p className="quote-subtitle">
                  Cód. Interno {quoteDetail?.quoteCode} | Cód. Cliente{" "}
                  {quoteDetail?.customerCode}{" "}
                  <Visibility visible={!!quoteDetail?.categoryMafra}>
                  | Cat. Cotação Mafra: {quoteDetail?.categoryMafra}
                  </Visibility>
                </p>
              </Column>
            </Row>
          </Column>
        </Row>

        <Row className='align-center mr-2'>
          <Column>
            <Row className="flex-row align-center">
              <Visibility visible={!distributionCentersButtonsHide.includes(distributionCenterSelected) && !isQuoteExpired}>
                <Column>{renderButtonObs()}</Column>

                <Visibility visible={false}>
                  <OrderReportButton />
                </Visibility>

                <Tooltip text={handleTooltipText()} disable={disableBtn}>
                  <Column className="flex-1">
                    <Button
                      onClick={() => handleUpdateQuotation()}
                      className={`${bgButton} sendBtn`}
                      disabled={disableBtn}
                    >
                      <Text className={textColor}>
                        {`Atualizar Cotação ( ${productSelected?.length} )`}
                      </Text>
                    </Button>
                  </Column>
                </Tooltip>
              </Visibility>

              <Visibility visible={distributionCenterSelected === 'default' && !unavailableCanceledQuote}>
                <Column>
                  <Row>
                    {renderButtonObs()}

                    <Tooltip text={handleTooltipText()} disable={disableBtn}>
                      <Column className="flex-1 sendBtn">
                        <Button
                          onClick={() => {
                            setModalPaymentTermModal(true);
                            setIsClickButtonFinally(true);
                          }}
                          height={40}
                          className={`${bgButtonNotSent} sendBtn`}
                          disabled={disableBtn}
                        >
                          <Text className={textColorNotSent}>
                            {`Enviar ( ${productSelected?.length} )`}
                          </Text>
                        </Button>
                      </Column>
                    </Tooltip>
                  </Row>

                  <Row className='justify-end'>
                    <Column className='selectDcSent'>
                      <Select
                        value={selectCD}
                        disabled={isOrder}
                        stateName="selectCD"
                        skipSelectOption={false}
                        defaultBlankValue="Selecione o CD"
                        className="selectCd bg-white outline"
                        options={distributionCenter.distributionCenters}
                        onChange={(e) => changeCDAndResetQuote(e.target.value)}
                      />
                    </Column>
                  </Row>
                </Column>
              </Visibility>

              <Visibility visible={!distributionCentersButtonsHide.includes(distributionCenterSelected) && isQuoteExpired && statusAnsweredPortal}>
                <Row className="flex-row">
                  {renderButtonObs()}

                  <Tooltip text={handleTooltipText()} disable={disableBtn}>
                    <Button
                      onClick={() => handleSendNegotiation()}
                      className={`${bgButton} sendBtn`}
                      disabled={disableBtn}
                    >
                      <Text className={textColor}>{`Enviar Negociação`}</Text>
                    </Button>
                  </Tooltip>
                </Row>
              </Visibility>
            </Row>

            <Row className="flex-row justify-end mt-2">
              <VisibilityConditional
                condition={isDownloadingQuotationMirror}
                firstOption={() => (
                  <Button className="btnDown" disabled>
                    <Text className="font-bold px-3">Baixando...</Text>
                  </Button>
                )}
                secondOption={() => (
                  <Tooltip text="Baixar espelho da cotação" disable={true}>
                    <Button
                      onClick={handleDownloadMirror}
                      className="btnDown">
                      <img src={DownloadTechnicalSheetBtn} />
                      <Text className="font-bold px-3">Baixar espelho</Text>
                    </Button>
                  </Tooltip>
                )}
              />
            </Row>
          </Column>
        </Row>
      </Row>

      <Column className="mt-2">
        <Visibility visible={!!(quoteDetail && quoteDetail?.financialPending?.length > 0)}>
          <ActionTag 
            tagTitle="Títulos em atraso" 
            onClick={handleOpenFinancialPendingMatterModal}
            hasMarginLeft />
        </Visibility>
        
        <Visibility visible={!!(quoteDetail?.hasPreOrder && preOrderDistributionCenters.length > 0)}>
          <ConfirmedOrdersAlert 
            distributionCenters={preOrderDistributionCenters}
            onClick={handleRedirectToOrders}
            hasMarginLeft />
        </Visibility>
      </Column>
      
      <QuoteHeaderInformations
        savedInMoneyPage={true}
        moneyBudgetValue={moneyBudgetValue}
        integrationMessages={integrationMessages}
      />

      <Visibility visible={!IsNullOrEmpty(quoteId)}>
        <LastHits quoteId={quoteId ?? ""} />
      </Visibility>

      <ErrorMessages
        origin={quoteDetail?.origin}
        errorMessageVisible={errorMessageVisible}
        integrationMessages={integrationMessages}
        distributionCenterSelected={distributionCenterSelected}
      />

      <ScrollToTop />

      <Visibility visible={modalPaymentTermModal}>
        <PaymentTermModal
          quoteId={quoteId ?? ""}
          popState={popState}
          paymentMethods={paymentMethods}
          productSelected={productSelected}
          quantityItems={getQtdItemsTotal()}
          newProductSelected={newProductSelected}
          onCloseAction={() => handleOnCloseAction()}
          allBudgetsSavedInQuote={allBudgetsSavedInQuote}
          distributionCenterSelected={distributionCenterSelected}
          handleChangeProductSelected={handleChangeProductSelected}
          isEditingQuote={!isQuoteExpired || (!isQuoteExpired && quoteDetail?.supplierStatus === SupplierStatusType.ANSWERED_PORTAL)}
        />
      </Visibility>

      <Visibility visible={viewSentQuotes}>
        <DistributionCenterTab
          hasMore={hasMore}
          setHasMore={setHasMore}
          quoteId={quoteId ?? ""}
          modalIsOpen={openModal}
          setShouldReset={setShouldReset}
          sequenceNumber={sequenceNumber}
          isQuoteExpired={isQuoteExpired}
          productSelected={productSelected}
          setSequenceNumber={setSequenceNumber}
          setPaymentMethods={setPaymentMethods}
          setRefreshControl={setRefreshControl}
          ableNegotiacionBtn={ableNegotiacionBtn}
          setProductSelected={setProductSelected}
          newProductSelected={newProductSelected}
          setOldSegmentSelected={setOldSegmentSelected}
          setQtdItemsAlreadySent={setQtdItemsAlreadySent}
          allBudgetsSavedInQuote={allBudgetsSavedInQuote}
          customerCode={`${quotesDetailsStore?.customerCode}`}
          setRemoveAllFromToSegment={setRemoveAllFromToSegment}
          setIsDeparaModalDisplayed={setIsDeparaModalDisplayed}
          distributionCenterSelected={distributionCenterSelected}
          handleChangeProductSelected={handleChangeProductSelected}
          setDistributionCenterSelected={setDistributionCenterSelected}
          distributionCenterName={distributionCenter.distributionCenters}
          distributionCenter={`${quotesDetailsStore?.distributionCenter}`}
          reproveMapProduct={reproveMapProduct}
          approveMapProduct={approveMapProduct}
        />
      </Visibility>

      <Visibility visible={openModal.isOpen && !selectCD}>
        <Modal
          children={
            <ModalCD
              onClick={setReset}
              selectCD={selectCDModal}
              setOpenModal={setOpenModal}
              setSelectCD={setSelectCDModal}
              handleCloseDcModal={handleCloseDcModal}
              distributionCenterSelected={distributionCenterSelected}
              distributionCenters={distributionCenter.distributionCenters}
            />
          }
          onCloseAction={() => { }}
          title=""
          width="10"
          height="100"
        />
      </Visibility>

      <Visibility visible={isDeparaModalDisplayed}>
        <div className="z-index-modal-quotes-mapping">
          <Modal title="" width="95%" borderRadius="8px" minWidth="" height="95%">
            <QuotesMapping
              quoteId={quoteId ?? ""}
              selectCD={selectCD}
              reloadTable={reloadTable}
              onCloseAction={hideDeParaModal}
              sequenceNumber={sequenceNumber}
              distributionCenter={distributionCenter}
              enableButtonApproveSuggestions={enableButtonApproveSuggestions}
            />
          </Modal>
        </div>
      </Visibility>

      <Visibility visible={openItemObsModal}>
        <Modal title="" width={"1100px"} height={"352px"}>
          <ObservationFieldModal
            item={{ ...quoteDetail, supplierNote, quoteId }}
            handleCloseItemObsModal={() => setOpenItemObsModal(false)}
            setSupplierNote={setSupplierNote}
          />
        </Modal>
      </Visibility>

      <Visibility visible={financialPendingMatterModal}>
        <Modal
          title=''
          width={'418px'}
          minWidth={'418px'}
          borderRadius={'8px'}
        >
          <FinancialPendingMatterModal
            financialCreditInformations={financialCreditInformations}
            handleCloseFinancialPendingMatterModal={handleCloseFinancialPendingMatterModal}
          />
        </Modal>
      </Visibility>

      <Visibility visible={showPriceHistoryModal && !IsNullOrEmpty(sequenceNumber) && !IsNullOrEmpty(itemPriceHistory)}>
        <PriceHistoryModal
          item={itemPriceHistory}
          quoteDetail={quoteDetail}
          onCloseAction={() => resetItemPriceHistory()}
          ableNegotiacionBtn={isQuoteExpired && !ableNegotiacionBtn}
        />
      </Visibility>

      <Subtitles subtitles={subtitlesQuoteDetails} />
    </DistributionCenterContext.Provider >
  );
};

export default SavedInMoney;